"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'NoticeComponent',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      id: null,
      // 公告列表数据
      noticeList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '添加公告',
      isEdit: false,
      currentEditId: null,
      // 二维码对话框
      qrCodeDialogVisible: false,
      qrCodeImage: '',
      // 表单数据
      formData: {
        tagName: '',
        title: '',
        content: '',
        selectedWeekdays: ['1', '2', '3', '4', '5', '6', '7'],
        // 默认全选
        startTime: '00:00',
        endTime: '00:00',
        isDisplayed: true,
        // 修改为布尔值
        type: 'normal'
      },
      // 表单验证规则
      formRules: {
        tagName: [{
          required: true,
          message: '请输入标签名',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入标题名',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }],
        selectedWeekdays: [{
          required: true,
          message: '请选择星期',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    // 组件创建时可以访问到传入的key值
    console.log('NoticeComponent - pageKey:', this.pageKey, 'moduleKey:', this.moduleKey);
    // 页面加载时获取已保存的配置
    this.loadConfig();
  },
  methods: {
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    // 添加公告
    handleAddNotice: function handleAddNotice() {
      this.dialogTitle = '添加公告';
      this.isEdit = false;
      this.dialogVisible = true;
      this.resetForm();
    },
    // 编辑公告
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        var loadingInstance, response, detailData, extraData, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loadingInstance = null;
              _context.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置项详情
              _context.next = 2;
              return (0, _decorateConfigItem.getConfigItemDetail)(row.id);
            case 2:
              response = _context.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                extraData = detailData.extra ? JSON.parse(detailData.extra) : {};
                this.dialogTitle = '编辑公告';
                this.isEdit = true;
                this.currentEditId = detailData.id;
                this.dialogVisible = true;

                // 填充表单数据
                this.formData = {
                  tagName: extraData.tagName || '',
                  title: extraData.title || '',
                  content: extraData.content || '',
                  selectedWeekdays: extraData.selectedWeekdays || ['1', '2', '3', '4', '5', '6', '7'],
                  startTime: extraData.startTime || '00:00',
                  endTime: extraData.endTime || '00:00',
                  isDisplayed: extraData.isDisplayed !== undefined ? extraData.isDisplayed : true,
                  type: extraData.type || 'normal'
                };
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t);
              this.$message.error('加载详情失败: ' + (_t.message || '未知错误'));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    // 生成二维码
    handleGenerateQrCode: function () {
      var _handleGenerateQrCode = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var loadingInstance, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              loadingInstance = null;
              _context2.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '生成二维码中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口生成二维码
              _context2.next = 2;
              return (0, _decorateConfigItem.generateQrCode)(row.id);
            case 2:
              response = _context2.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 显示二维码对话框
                this.qrCodeImage = response.data.image || ''; // 假设后端返回的是imageUrl字段
                this.qrCodeDialogVisible = true;
              } else {
                this.$message.error(response.message || '生成二维码失败!');
              }
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('生成二维码失败:', _t2);
              this.$message.error('生成二维码失败: ' + (_t2.message || '未知错误'));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleGenerateQrCode(_x2) {
        return _handleGenerateQrCode.apply(this, arguments);
      }
      return handleGenerateQrCode;
    }(),
    // 移除公告
    handleRemove: function handleRemove(row) {
      var _this = this;
      this.$confirm('确定要移除这条公告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _decorateConfigItem.deleteConfigItem)(row.id);
            case 1:
              response = _context3.sent;
              if (!(response.code === 200)) {
                _context3.next = 3;
                break;
              }
              _context3.next = 2;
              return _this.loadConfig();
            case 2:
              _this.$message.success('移除成功');
              _context3.next = 4;
              break;
            case 3:
              _this.$message.error(response.message || '删除失败!');
            case 4:
              _context3.next = 6;
              break;
            case 5:
              _context3.prev = 5;
              _t3 = _context3["catch"](0);
              console.error('删除失败:', _t3);
              _this.$message.error('删除失败: ' + (_t3.message || '未知错误'));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 5]]);
      }))).catch(function () {
        _this.$message.info('已取消移除');
      });
    },
    // 切换显示状态
    handleToggleVisibility: function () {
      var _handleToggleVisibility = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context4.sent;
              if (response.code === 200) {
                // 更新成功后刷新列表
                // await this.loadConfig();
                this.handleSizeChange(this.pageSize);
                this.$message.success("\u516C\u544A".concat(row.enable ? '已开启' : '已关闭', "\u663E\u793A"));
              } else {
                // 如果接口调用失败，恢复开关状态
                row.enable = !row.enable;
                this.$message.error(response.message || '操作失败!');
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              console.error('操作失败:', _t4);
              this.$message.error('操作失败: ' + (_t4.message || '未知错误'));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function handleToggleVisibility(_x3) {
        return _handleToggleVisibility.apply(this, arguments);
      }
      return handleToggleVisibility;
    }(),
    // 提交表单
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var loadingInstance, data, response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              loadingInstance = null;
              _context5.prev = 1;
              data = {
                id: this.currentEditId,
                // 使用currentEditId而不是this.id
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                title: this.formData.title,
                enable: this.formData.isDisplayed,
                extra: JSON.stringify(this.formData)
              }; // 显示保存loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口保存配置
              _context5.next = 2;
              return (0, _decorateConfigItem.saveConfigItem)(data);
            case 2:
              response = _context5.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (!(response.code === 200)) {
                _context5.next = 4;
                break;
              }
              // 保存成功后关闭对话框而不是打开
              this.handleDialogClose();
              this.isEdit = false;
              this.dialogVisible = false;
              // 刷新列表数据
              _context5.next = 3;
              return this.loadConfig();
            case 3:
              this.$message.success('公告配置保存成功');
              _context5.next = 5;
              break;
            case 4:
              this.$message.error(response.message || '保存失败!');
            case 5:
              _context5.next = 7;
              break;
            case 6:
              _context5.prev = 6;
              _t5 = _context5["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('保存失败:', _t5);
              this.$message.error('保存失败: ' + (_t5.message || '未知错误'));
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 6]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 关闭对话框
    handleDialogClose: function handleDialogClose() {
      this.resetForm();
      console.log('关闭对话框');
      console.log(this.formData);
    },
    // 重置表单
    resetForm: function resetForm() {
      this.currentEditId = null;
      this.formData = {
        tagName: '',
        title: '',
        content: '',
        selectedWeekdays: ['1', '2', '3', '4', '5', '6', '7'],
        startTime: '00:00',
        endTime: '00:00',
        isDisplayed: true,
        type: 'normal'
      };
      if (this.$refs.noticeForm) {
        this.$refs.noticeForm.clearValidate();
      }
    },
    // 预览配置
    handlePreview: function handlePreview() {
      var config = {
        noticeList: this.noticeList
      };
      console.log('预览公告配置:', config);
      this.$message.info('预览功能开发中...');
    },
    // 应用配置
    handleApply: function handleApply() {
      var config = {
        noticeList: this.noticeList
      };
      console.log('应用公告配置:', config);
      this.$message.success('公告配置应用成功');
    },
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var loadingInstance, response, _t6;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              loadingInstance = null;
              _context6.prev = 1;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置
              _context6.next = 3;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize);
            case 3:
              response = _context6.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 解析配置信息
                // ✅ 展开 extra 到每条记录中
                this.noticeList = response.records.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    extra: item.extra ? JSON.parse(item.extra) : {}
                  });
                });
                this.total = response.total;
                this.currentPage = response.current;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              // 如果response.data为空，说明还没有保存过配置，使用默认值
              _context6.next = 5;
              break;
            case 4:
              _context6.prev = 4;
              _t6 = _context6["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t6);
              this.$message.error('配置加载失败: ' + (_t6.message || '未知错误'));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 4]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }()
  }
};